import { render, staticRenderFns } from "./freightHandle.vue?vue&type=template&id=56e12b93&"
import script from "./freightHandle.vue?vue&type=script&lang=js&"
export * from "./freightHandle.vue?vue&type=script&lang=js&"
import style0 from "./freightHandle.vue?vue&type=style&index=0&id=56e12b93&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports